import React from 'react';
import { Box } from '@mui/material';
import './LearnerTableSkeleton.css';

const LearnerTableSkeleton = ({ rows = 10 }) => {
  return (
    <Box className="learner-skeleton-container">
      <table className="learner-skeleton-table">
        <thead>
          <tr>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
            <th className="learner-skeleton-th">
              <Box className="learner-skeleton-box header-skeleton" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} className="learner-skeleton-row">
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-name-container">
                  <Box className="learner-skeleton-avatar" />
                  <Box className="learner-skeleton-box name-skeleton" />
                </Box>
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-badge" />
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-box text-skeleton-short" />
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-box text-skeleton-short" />
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-box text-skeleton" />
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-box text-skeleton" />
              </td>
              <td className="learner-skeleton-td">
                <Box className="learner-skeleton-badge-container">
                  <Box className="learner-skeleton-status-badge" />
                </Box>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default LearnerTableSkeleton;
